import decode from 'jwt-decode'

export function isValidToken (token) {
  try {
    decode(token)
    return true
  } catch (e) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/shared/utils/auth/validations.js